import {css} from 'lit';
export const styles = css`:host{height:100%;width:100%}.screen-wrapper{min-height:100%;width:100%;display:flex}.screen-sidebar{flex:0 0 auto}.screen-content{flex:1 1 100%;display:flex;flex-direction:column;overflow:hidden}.screen-navbar{width:100%}.screen-body{width:100%;background:var(--atlas-light);flex:1 1 auto;box-sizing:border-box}`;
export default styles;
